import type { TranslationResource } from './en';

export const it: TranslationResource = {
  title: 'AutoCut - Programma di installazione',
  downloading: 'Download di AutoCut in corso',
  downloadedTitle: 'AutoCut è stato scaricato con successo !',
  closingCountdown: 'Chiusura tra {{count}} secondi',
  alreadyInstalledTitle: 'AutoCut è già installato',
  alreadyInstalledHelp:
    'AutoCut ora funziona come applicazione desktop. Puoi disinstallare questa estensione dall’app Creative Cloud.',
};
